import axios from 'axios';

let baseUrl = '';
if (process.env.VUE_APP_BASE_URL) {
	baseUrl = process.env.VUE_APP_BASE_URL;
}

let upload = axios.create({
	baseURL: baseUrl,
	timeout: 1000 * 120
});

upload.defaults.headers.post['Content-Type'] = 'multipart/form-data';

// 响应拦截
upload.interceptors.response.use(onResponseFulfilled, onResponseRejected);

function onResponseFulfilled(res) {
	let {data, status} = res;
	const {jsonr: {
		data: _data,
		errmsg: msg,
		status: _status
	}} = parseResponseData(data);
	if (status === 200) {
		if (_status === '00') {
			return Promise.resolve(_data);
		}
	}
	return Promise.reject({
		code: _status,
		msg,
		response: res
	});
}

function onResponseRejected(error) {
	const {response} = error;
	if (response) {
		// 请求已发出，但是不再2xx的范围
		return Promise.reject({
			code: response.status,
			msg: '请求错误',
			response
		});
	} else {
		if (!window.navigator.onLine) {
			// 断网
			return Promise.reject({
				code: '601',
				msg: '断网了',
				response
			});
		} else {
			return Promise.reject(error);
		}
	}
}

function parseResponseData(data) {
	if (data) {
		return JSON.parse(data.replace(/^\*\*YGKJ/, '').replace(/YGKJ##$/, '') || '{}');
	}
	return {};
}

export default upload;
